export default __webpack_public_path__ + "static/media/paypal.dc5ad82b.svg";